import { questionGroupsHeaderUtil } from '@doltech/ui/lib/figma/QuestionGroupGuideline/utils/questionGroupsHeaderUtil';
import { QuestionTypeEnum } from '@doltech/utils/lib/constants';
import { types as t } from 'mobx-state-tree';

import { QuestionGroup } from '../../question-data-model/question-group.store';
import { ResultCompletionNoHintQuestion } from './Question/result-completion-no-hint-question.store';
import { ResultDiagramLabelQuestion } from './Question/result-diagram-label-question.store';
import { ResultDragInQuestion } from './Question/result-drag-in-question.store';
import { ResultDragOutQuestion } from './Question/result-drag-out-question.store';
import { ResultFlowChartComplexQuestion } from './Question/result-flow-chart-complex.store';
import { ResultFlowChartQuestion } from './Question/result-flowchart-question.store';
import { ResultMatchingEndingQuestion } from './Question/result-matching-ending-question.store';
import { ResultMatchingFeatureNameQuestion } from './Question/result-matching-feature-name-question.store';
import { ResultMatchingHeadingQuestion } from './Question/result-matching-heading-question.store';
import { ResultMatchingParagraphQuestion } from './Question/result-matching-paragraph-question.store';
import { ResultMultipleAnswerQuestion } from './Question/result-multiple-answer-question.store';
import { ResultSentenceCompleteQuestion } from './Question/result-sentence-complete-question.store';
import { ResultShortQuestion } from './Question/result-short-question.store';
import { ResultSingleAnswerQuestion } from './Question/result-single-answer-question.store';
import { ResultTableCompletionQuestion } from './Question/result-table-completion-question.store';
import { ResultTFNQuestion } from './Question/result-tfn-question.store';
import { ResultYNNQuestion } from './Question/result-ynn-question.store';

export const ResultTestQuestionGroupStore = QuestionGroup.props({
  questions: t.maybeNull(
    t.array(
      t.union(
        {
          dispatcher: (s) => {
            switch (s.type) {
              case QuestionTypeEnum.SINGLE_ANSWER:
                return ResultSingleAnswerQuestion;
              case QuestionTypeEnum.TFN_ANSWER:
                return ResultTFNQuestion;
              case QuestionTypeEnum.YNN_ANSWER:
                return ResultYNNQuestion;
              case QuestionTypeEnum.MULTIPLE_ANSWER:
                return ResultMultipleAnswerQuestion;
              case QuestionTypeEnum.MATCHING_HEADING:
                return ResultMatchingHeadingQuestion;
              case QuestionTypeEnum.MATCHING_PARAGRAPH:
                return ResultMatchingParagraphQuestion;
              case QuestionTypeEnum.MATCHING_ENDING:
                return ResultMatchingEndingQuestion;
              case QuestionTypeEnum.MATCHING_FEATURE_NAME:
                return ResultMatchingFeatureNameQuestion;
              case QuestionTypeEnum.SHORT_ANSWER:
                return ResultShortQuestion;
              case QuestionTypeEnum.SENTENCE_COMPLETE:
                return ResultSentenceCompleteQuestion;
              case QuestionTypeEnum.NOTE_COMPLETION_WITH_HINT:
              case QuestionTypeEnum.NOTE_COMPLETION_NO_HINT:
                return ResultCompletionNoHintQuestion;
              case QuestionTypeEnum.FLOWCHART_ANSWER:
                return ResultFlowChartQuestion;
              case QuestionTypeEnum.DIAGRAM_LABEL_COMPLETION:
                return ResultDiagramLabelQuestion;
              case QuestionTypeEnum.TABLE_COMPLETION:
                return ResultTableCompletionQuestion;
              case QuestionTypeEnum.DRAG_IN:
                return ResultDragInQuestion;
              case QuestionTypeEnum.DRAG_OUT:
                return ResultDragOutQuestion;
              case QuestionTypeEnum.FLOW_CHART_COMPLEX:
                return ResultFlowChartComplexQuestion;
              default:
                throw new Error(`Cannot resolve Question Type "${s.type}"`);
            }
          },
        },
        ResultSingleAnswerQuestion,
        ResultTFNQuestion,
        ResultYNNQuestion,
        ResultMultipleAnswerQuestion,
        ResultMatchingHeadingQuestion,
        ResultMatchingParagraphQuestion,
        ResultMatchingEndingQuestion,
        ResultShortQuestion,
        ResultSentenceCompleteQuestion,
        ResultCompletionNoHintQuestion,
        ResultMatchingFeatureNameQuestion,
        ResultFlowChartQuestion
      )
    )
  ),
})
  .named('ResultResultTestQuestionGroupStore')
  .views((self) => ({
    getQuestions() {
      const questions = [];
      self.questions.forEach((question: any) => {
        questions.push(...question.getQuestions());
      });
      return questions;
    },
    getQuestionGroupsFromNoToNo() {
      return questionGroupsHeaderUtil(self.questions);
    },
  }));
